import { useRef } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import styles from './ReportEmbed.module.css';

/**
 * ReportEmbed — wraps powerbi-client-react with sensible defaults.
 *
 * NOTE (DEV mode): Because this uses trial embed tokens generated with a
 * Pro licence and no Azure capacity, Power BI will display a
 * "Free Trial Version" banner at the top of the report.
 * This is expected behaviour in development and does NOT affect functionality.
 */
export default function ReportEmbed({ embedToken, embedUrl, reportId }) {
  const reportRef = useRef(null);

  const embedConfig = {
    type: 'report',
    id: reportId,
    embedUrl,
    accessToken: embedToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: { expanded: false, visible: true },
        pageNavigation: { visible: true },
      },
      background: models.BackgroundType.Default,
    },
  };

  const eventHandlers = new Map([
    ['loaded', () => console.log('Report loaded')],
    ['rendered', () => console.log('Report rendered')],
    ['error', (event) => console.error('Report embed error:', event.detail)],
  ]);

  return (
    <div className={styles.wrapper}>
      <PowerBIEmbed
        embedConfig={embedConfig}
        eventHandlers={eventHandlers}
        cssClassName={styles.embed}
        getEmbeddedComponent={(embeddedReport) => {
          reportRef.current = embeddedReport;
        }}
      />
    </div>
  );
}
